import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { AuthGuard } from './shared';
import { DeviceNewProfileProcedureComponent } from './device-new-profile-procedure/device-new-profile-procedure.component';
import { DeviceNewGroupProcedureComponent } from './device-new-group-procedure/device-new-group-procedure.component';
import { LoginComponent } from './login/login.component';

const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'prefix' },
    { path: '', loadChildren: './layout/layout.module#LayoutModule'},
    { path: 'login', component: LoginComponent },
    { path: 'device-new-profile/profiles', component: DeviceNewProfileProcedureComponent },
    { path: 'device-new-group/group', component: DeviceNewGroupProcedureComponent },
    { path: 'user-new-group/user', loadChildren: './user-new-group-procedure/user-new-group-procedure.module#UserNewGroupProcedureModule' },
      // { path: 'signup', loadChildren: './signup/signup.module#SignupModule' },
    { path: 'error', loadChildren: './server-error/server-error.module#ServerErrorModule' },
    { path: 'access-denied', loadChildren: './access-denied/access-denied.module#AccessDeniedModule' },
    { path: 'not-found', loadChildren: './not-found/not-found.module#NotFoundModule' },
    { path: '**', redirectTo: 'not-found' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
